import React from "react"
import { navigate } from "gatsby"
import * as style from "./cta.module.css"
import ScrollButton from "../../buttons/scrollButton/scrollButton"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import OptimizedImage from "../../ImageShow/OptimizedImage"

const Cta = ({ CustomClass, cta1Tag, cta1Title, cta1Cta, cta1ShowSection, ctaImage }) => {
  const handleClick = () => {
    navigate(cta1Cta.url)
  }

  return (
    <>
      {cta1ShowSection === "yes" && (
        <section className={`${CustomClass}`}>
          <div className="container">
            <div className={style.cta_content_wrap}>
              <div className={style.cta_info_wrap}>
                <div className={style.cta_info_content}>
                  <SectionsTitle
                    SubTitle={cta1Title}
                    styleCss={{ display: "none" }}
                    classnames={`${style.cat_main_title}`}

                  />
                  <ScrollButton
                    onClick={() => handleClick()}
                    btnText={cta1Cta?.title}
                    customClass={style.cta_btn}
                  />
                </div>
              </div>
              <div className={style.img_section}>
                <OptimizedImage
                  // pictureclass={style.quoteImage}
                  imageData={ctaImage?.mediaItemUrl ? ctaImage?.mediaItemUrl : "/images/new/cta_bg_image_2.png"}
                  alt={ctaImage?.altText ? ctaImage?.altText : "ctastate"}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default Cta
